<template>
    <!-- 权限配置 -->
    <div class="page-container user-roles-page"
    id="permissionConfigurationContainer">
        <el-row :gutter="5" class="user-roles-content">
            <el-col :span="6" style="margin-right: 10px">
                <el-input size="mini"
                v-model="permissionConfigForm.use_code"
                 placeholder="输入名称按'回车'快速定位"
                 @change="positioning"
                 ></el-input>
                <!-- <el-row style="margin-top: 8px">
                    <el-col>
                        <el-row class="name-css" :class="{ selectBg: index === isactive }" v-for="(item, index) in nameList" :key="index" @click.native="handlerSelect(index)">
                            {{item}}
                        </el-row>
                    </el-col>
                </el-row> -->
                <el-tree
                :data="treeData"
                :props="defaultProps"
                @node-click="handleNodeClick"
                 node-key="id"
                 ref="RoleTree"
                 :highlight-current="true"
                 :default-expand-all="true"
                 :expandOnClickNode="false"
                >
                </el-tree>
            </el-col>
            <el-col :span="18">
                <el-form :model="permissionConfigForm" :rules="permissionConfigFormRules" ref="ruleFormRef" class="form-panel" label-position="top"
                    :validateOnRuleChange="false">
                    <el-col :span="24">
                        <el-row class="content-panel border-radius">
                            <el-col style="margin-bottom:8px">
                                <el-button type="primary" size="small" plain @click="increaseRole" class="el-button-search">新增</el-button>
                                <el-button type="primary" size="small" plain @click="saveRole">保存</el-button>
                                <el-button type="primary" size="small" plain @click="handleAdd">导入权限</el-button>
                                <el-button type="primary" size="small" plain @click="handleEnable">单个角色缓存刷新</el-button>
                                <el-button type="danger" size="small" plain @click="handleDisable">刷新所有缓存</el-button>
                                <el-button type="danger" size="small" plain @click="deleteRole">删除角色</el-button>
                            </el-col>
                            <el-col>
                                <el-row :gutter="22">
                                    <el-col :span="8">
                                        <el-form-item label="角色代码" prop="roleCode">
                                            <el-input size="mini" v-model="permissionConfigForm.roleCode" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="角色名称" prop="roleName">
                                            <el-input size="mini" v-model="permissionConfigForm.roleName" ></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="上级角色" prop="parentRoleName">
                                            <el-input size="mini" v-model="permissionConfigForm.parentRoleName" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="22">
                                    <el-col :span="16">
                                        <el-form-item label="角色描述" prop="roleDesc">
                                            <el-input size="mini" v-model="permissionConfigForm.roleDesc"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="主数据ID" prop="mdmId">
                                            <el-input size="mini" v-model="permissionConfigForm.mdmId"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <!-- 表格-start -->
                        <el-row class="tabsContainer tab-module">
                            <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane label="操作权限" name="1">
                                    <!-- <el-form :model="orgForm" :rules="orgFormRules" ref="orgFormRef" label-position="top">
                                        <el-row>
                                            <el-col :span="6">
                                                <el-form-item label="默认组织" prop="use_code">
                                                    <el-input size="mini" v-model="orgForm.use_code"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-tree
                                                :data="data"
                                                show-checkbox
                                                node-key="id"
                                                :props="defaultProps">
                                            </el-tree>
                                        </el-row>
                                    </el-form> -->
                                    <el-button size="small" type="primary" @click="expandNode">展开节点</el-button>
                                    <el-button size="small" type="primary" @click="contractionNode">收缩节点</el-button>
                                    <el-button size="small" type="danger" @click="clearSelected">清空已选</el-button>
                                     <el-tree
                                        :data="ResourceTree"
                                        :props="defaultProps"
                                        show-checkbox
                                        :check-strictly="true"
                                        >
                                     </el-tree>
                                </el-tab-pane>
                                <el-tab-pane label="授权权限" name="2"></el-tab-pane>
                                <el-tab-pane label="角色用户" name="3"></el-tab-pane>
                                <el-tab-pane label="待办权限" name="4"></el-tab-pane>
                                <el-tab-pane label="状态树权限" name="5">
                                    <el-row>
                                        <el-button type="primary" @click="addPermissions" clearSelected>新增</el-button>
                                        <el-button type="danger" @click="deletePermissions" clearSelected>删除</el-button>
                                    </el-row>
                                      <el-row class="panel-top">
                                    <hot-table
                                        ref="todoAtree"
                                        :data-source="todoAtreeDataSource"
                                        :settings="todoAtreeSettings"
                                        col-settings-key="permission"
                                    >
                                        <hot-column
                                        :has-tip="true"
                                        data="brokerMblNo"
                                        title="状态树名称"
                                        >
                                        <el-input-editor
                                            :controls="true"
                                            hot-editor
                                            name="stateTreeName"
                                            case="upper"
                                        />
                                        </hot-column>
                                        <hot-column
                                        :has-tip="true"
                                        data="brokerMblNo"
                                        title="状态树节点配置名称"
                                        >
                                        <el-input-editor
                                            :controls="true"
                                            hot-editor
                                            name="configurationName"
                                            case="upper"
                                        />
                                        </hot-column>
                                    </hot-table>
                                      </el-row>
                                </el-tab-pane>

                            </el-tabs>
                        </el-row>
                    </el-col>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getRoleTree,getSysRole, getResourceTree,saveSysRole,deleteSysRole,updateSysRole } from  '@/api/system'
import { getTreeData } from '@/utils/common'
export default {
    data() {
        return {
            nameList: ['分公司系统管理员', '整箱操作'],
            isactive: 0, //默认第一个有样式
            activeName: '1',
				permissionConfigForm: {},
				// 分页
				pageConfig: {
					layout: 'total, sizes, pFrev, pager, next, jumper',
					total: 0,
					pageSize: 10,
					pagerCount: 10,
					currentPage: 1,
					pageSizes: [10, 20, 50, 100]
				},
				// // currentPage 改变时会触发
				// handleCurrentChange(val) {
				// 	console.log(`当前页: ${val}`)
				// 	this.pageConfig.currentPage = val
				// },
				// 校验
				permissionConfigFormRules: {
                    use_code: [{ required: true, message: '' }],
                },
                orgForm: {},
                orgFormRules: {
                    use_code: [{ required: true, message: '' }],
                },
				// 表格数据
				userManagementTableDataSource: [],
				// 表格设置
				userManagementTableSettings: {
					height: 360,
					stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
					...this.$systemConfig.tableConfig

				},
                isValidList: [
                    {
                        key: '1',
                        value: '是'
                    },
                    {
                        key: '0',
                        value: '否'
                    }
                ],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                        picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                        }
                    }]
                },
               data: [{
                id: 1,
                label: '公共相关',
                    children: [{
                        id: 4,
                        label: '二级 1-1',
                        children: [{
                        id: 9,
                        label: '三级 1-1-1'
                        }, {
                        id: 10,
                        label: '三级 1-1-2'
                        }]
                    }]
                }, {
                id: 2,
                    label: '结算管理',
                    children: [{
                        id: 5,
                        label: '二级 2-1'
                    }, {
                        id: 6,
                        label: '二级 2-2'
                    }]
                }, {
                id: 3,
                label: '价格协议',
                    children: [{
                        id: 7,
                        label: '二级 3-1'
                    }, {
                        id: 8,
                        label: '二级 3-2'
                    }]
                    }],
                //     defaultProps: {
                //     children: 'children',
                //     label: 'label'
                // },
        todoAtreeDataSource: [],
        todoAtreeSettings: {
        height: 360,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
        },
        treeData: [],
        ResourceTree: [],
        defaultProps: {
            label: 'name',
            children: 'children'
        },
        sysRoleId: '',
        noChangeTreeData: [],
        ResourceTreedata: {
            // pid: self.treeData[0].pid,
            // sysRoleId: self.treeData[0].id,
            pid: '',
            sysRoleId: '',
        },
        targetName: '',
        targetpid: '',
        targetSysRoleId: '',
        };
    },
    async created() {

    },
    mounted() {
        	let self = this
			// 监听外层容器div宽度的变化，做表格自适应
			self.resizeObserver = new ResizeObserver(entries => {
				self.$nextTick(() => {
					self.$refs.todoAtree.resizeTo(entries[0].target.clientWidth - 32)
				})
			})
         self.getRoleTree()
    },
    methods: {
        // 获取左边树
        getRoleTree(getRoleTreeId) {
            let self=this
            getRoleTree().then((res) => {
                if(getRoleTreeId===''||getRoleTreeId===undefined||getRoleTreeId===null){
              if(res.result && res.result instanceof Array) {
                  console.log(res)
                  self.treeData=  getTreeData(res.result);
                  self.$nextTick(() => {
                self.$refs.RoleTree.setCurrentKey(self.treeData[0].id)
            })
            self.getSysRole(self.treeData[0].id);
             self.ResourceTreedata.pid=self.treeData[0].id
            self.ResourceTreedata.sysRoleId=self.treeData[0].id
            self.getResourceTrees()
              }
                }else{
                    if(res.result && res.result instanceof Array) {
                  self.treeData=  getTreeData(res.result);
                  self.$nextTick(() => {
                self.$refs.RoleTree.setCurrentKey(getRoleTreeId)
            })
            self.getSysRole(getRoleTreeId);
              }
                }
            })
            // let is res.result.find(item => item.name.)
        },
        // 获取被点击树节点的操作权限中的树
        getResourceTrees(){
            let self=this
        getResourceTree(self.ResourceTreedata).then((res) => {
               let arr= getTreeData(res.result);
               this.ResourceTree=arr;
            })
        },
        // 点击树节点，右边input框显示对应数据
        handleNodeClick(target){
            let self=this
            self.targetName=target.name
            self.targetpid=target.pid
            self.targetSysRoleId=target.id
            self.getSysRole(target.id)
            if(target.pid){
            self.ResourceTreedata.pid=target.pid
            self.ResourceTreedata.sysRoleId=target.id
            }else{
            self.ResourceTreedata.pid=target.id
            self.ResourceTreedata.sysRoleId=target.id
            }

            self.getResourceTrees()
        },
        // 获取树节点的数据
         getSysRole(id){
             let self=this
            let data={
                 sysRoleId: id
            }
         getSysRole(data).then((res) => {
             if(res.success) {
             self.permissionConfigForm = res.sysRole;
             self.ResourceTreedata.pid=res.sysRole.parentRoleId
             self.ResourceTreedata.sysRoleId=self.targetpid
             self.getResourceTrees()
             }
              })
         },
         positioning(value){
            //  console.log(value)
            let self=this
           let targetNode=self.noChangeTreeData.find((item) =>  { return item.name.includes(value) } )
           self.$refs.RoleTree.setCurrentKey(targetNode.id)
         },
        loadNode(node, resolve) {
            if (node.level === 0) {
            return resolve([{ name: '华贸股份' }]);
            }
            if (node.level > 1) return resolve([]);

            setTimeout(() => {
            const data = [{
                name: 'leaf',
                leaf: true
            }, {
                name: 'zone'
            }];

            resolve(data);
            }, 500);
        },
        handleClick(){},
        // 新增
        increaseRole() {
            let self=this
            console.log("新增")
            // self.permissionConfigForm=''
            self.targetpid=self.targetSysRoleId
            self.permissionConfigForm.roleCode=''
            self.permissionConfigForm.roleName=''
            self.permissionConfigForm.roleDesc=''
            self.permissionConfigForm.mdmId=''
            self.permissionConfigForm.parentRoleName=self.targetName
        },
        // 保存
        saveRole(){
            let self=this
            let userInfo=JSON.parse(localStorage.getItem('userInfo'))
           let saveRoleData = {
            operaAuthChecks: [],
            roleGrantChecks: [],
            sysRole: {
            deptOffice: userInfo.deptOfficeId,
                deptOfficeName: userInfo.deptOfficeName,
                isDeleted: "0",
                mdmId: self.permissionConfigForm.mdmId,
                parentRoleId: self.targetSysRoleId ,
                parentRoleName: self.targetName,
                roleDesc: self.permissionConfigForm.roleDesc,
                roleName: self.permissionConfigForm.roleName,
                rowStatus: '4',
            }
            }
            if(self.permissionConfigForm.roleCode===''||self.permissionConfigForm.roleCode===null||self.permissionConfigForm.roleCode===undefined){
                // 新增
            saveSysRole(saveRoleData).then((res) => {
            self.$refs.RoleTree.setCurrentKey(self.targetpid)
            self.getRoleTree(self.targetpid)
            self.getSysRole(self.targetpid);
            })
            }else{
                // 更新
                self.updateSysRole()
            }
        },
        // 删除
        deleteRole(){
            let self=this
            let deleteRoleData={
                sysRoleId: self.targetSysRoleId
                }
            deleteSysRole(deleteRoleData).then((res) => {
            self.$refs.RoleTree.setCurrentKey(self.targetpid)
            self.getRoleTree(self.targetpid)
            })
        },
        // 更新
        updateSysRole(){
            let self=this
            let updateRoleData={
                operaAuthChecks: [],
                roleGrantChecks: [],
                sysRole: self.permissionConfigForm
              }
             console.log(updateRoleData)
              updateSysRole(updateRoleData).then( (res) => {
            self.getRoleTree(self.targetpid)
            self.getSysRole(self.targetpid);
              } )
        },
        // 重置密码
        handleResetPwd() {

        },
        // 启用
        handleEnable() {

        },
        // 禁用
        handleDisable() {

        },
        // 查询
        handleQuery() {

        },
        // 重置
        handleReset() {

        },
        // pageSize 改变时会触发
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`)
            this.pageConfig.pageSize = val
        },
        // currentPage 改变时会触发
        handleCurrentChange(val) {
            this.pageConfig.currentPage = val
        },
        handlerSelect(index) {
            //点击切换 变量的值 赋值为 index
            this.isactive=index;
        }
    }
};
</script>

<style scoped lang="scss">
/* .el-tabs--border-card {
    margin-top: 10px;
    border:none !important;
    -webkit-box-shadow:none !important;
    box-shadow: none !important;
    .el-tabs__content {
  display: none !important;
}
} */
.name-css {
  font-size: 14px;
  padding: 4px 2px;
  cursor: pointer;
}
.selectBg {
  background: #e1e9fa;
}
::v-deep .el-col-6 .el-input__inner{
    border-radius: 10px !important;
    margin:10px 0 10px 8px;
    width: 95%;
}
::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background: linear-gradient(90deg, rgba(46, 136, 255, 0) 0%, #2d87fe 400%) ;
    color: #2e88ff !important;
}
.user-roles-content {
  /*  padding:0px !important; */
  display: flex;
  position: relative;

  .el-col-6{
    border-radius: 10px !important;
    min-height: 100% !important;
    background-color: #fff !important;
  }
  .el-col-18{
    min-height:100% !important;

  }
}
.handsontable {
  margin-top: 20px;
  min-width: 500px;
}
::v-deep .el-tabs__content{
  min-height: 450px;
}
.tabsContainer{
  .el-tree{
    margin-top: 10px !important;
  }
}
</style>
